import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'
import Button from '../../common/CustomComponents/Button.js'

class YachtPolicyAdd extends React.Component {
  state = {
    isData: false,
    yacht_policy_en: '',
    yacht_policy_ar: '',
  }

  componentDidMount() {
    this.loadData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language_id !== this.props.language_id) {
      this.loadData()
    }
  }

  loadData = async () => {
    await axios
      .get(Constant.getAPI() + `/client/get-client-settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState(res.data.data)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (value) => {
    this.setState({ yacht_policy_en: value, yacht_policy_ar: value })
  }

  onSave = () => {
    var data

    if (this.props.language_id === 'en') {
      data = {
        id: this.state.id,
        yacht_policy_en: this.state.yacht_policy_en,
      }
    } else {
      data = {
        id: this.state.id,
        yacht_policy_ar: this.state.yacht_policy_ar,
      }
    }

    this.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/client/update-client-settings', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-12 mb-2">
            {this.props.language_id === 'en' ? (
              <ReactQuill
                value={this.state.yacht_policy_en}
                onChange={this.handleChange}
              />
            ) : (
              <ReactQuill
                value={this.state.yacht_policy_ar}
                onChange={this.handleChange}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-right">
            <Button
              disabled={this.state.isData}
              startIcon={<i className="icofont icofont-save"></i>}
              onClick={this.onSave}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default YachtPolicyAdd
